import { render, staticRenderFns } from "./Convention.vue?vue&type=template&id=c68ffb20&scoped=true&"
import script from "./Convention.vue?vue&type=script&lang=js&"
export * from "./Convention.vue?vue&type=script&lang=js&"
import style0 from "./Convention.vue?vue&type=style&index=0&id=c68ffb20&prod&scoped=true&lang=css&"
import style1 from "./Convention.vue?vue&type=style&index=1&id=c68ffb20&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c68ffb20",
  null
  
)

export default component.exports